import React from "react";
import cx from "classnames";
import styles from "./Statistics.module.scss";

interface IProps {
  number: string;
  title: string;
  content: string;
}

export default function Item({ number, title, content }: IProps) {
  return (
    <div
      className={cx("flex flex-col items-center", styles["statistics-item"])}
    >
      <div className={cx(styles.number)}>{number}</div>
      <div className={cx(styles.title)}>{title}</div>
      <div className={cx("px-2 pb-3", styles.content)}>{content}</div>
    </div>
  );
}
